import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to top whenever the route changes.
// If the URL has a hash (e.g. /milyen-terbe-erkezel#egyseg), scrolls to that anchor.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait one frame for the target route to mount its DOM, then scroll to the anchor
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({ behavior: "instant", block: "start" });
          return;
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
